module.exports = __webpack_public_path__ + "img/dep_partysupply@2x.e5bff01f.png";